export default {
    "locale": "en-US",
    "lang": "en",
    "yes": "Yes",
    "no": "No",
    "and": "and ",
    "or": "or ",
    "loading": "Loading",
    "disconnected": "You are offline... Trying to reconnect",
    "ok": "OK",
    "error": "Oops! We have a critical failure here... But that's ok, there will be a fix soon ;)",
    "errorshow": "Oops! This expression didnt work... Need some help?",
    "genericError": "Critical Failure here! Please refresh the page",
    "undefinederror": "Undefined error",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "add": "Add",
    "edit": "Edit",
    "delete": "Delete",
    "send": "Send",
    "version": "Version",
    "update": "updated at",
    "back": "Back",
    "datelong": "$1, $3 $2, $4",
    "login": {
        "email": "Email",
        "password": "Password",
        "login": "Login",
        "name": "Name",
        "color": "Color",
        "confirm": "Confirm Password",
        "cancel": "Cancel",
        "create": "Create",
        "next": "Next",
        "forgot": "Forgot my password",
        "forgotText1": "Don't worry! Type your email and we will start to reset your password",
        "forgotText2": "Great, now check your email. You need to inform here the code provided in the email",
        "code": "Code",
        "reset": "Reset",
        "newPassword": "New Password",
        "gotoNewProfile": "Create new profile"
    },
    "profile": {
        "title": "Profile",
        "edit": "Edit Profile",
        "save": "Save Profile",
        "currentpass": "Current password",
        "name": "Name",
        "changepassword": "Change Password",
        "newpass": "New Password",
        "newpassconfirm": "Confirm New Password",
        "color": "Player's color",
        "logout": "Logout",
        "remove": "Delete account",
        "confirmremove": "Do you really wnat to delete your account? ALL all your data will be removed permanently and cannot be restored anymore :(",
        "noMobile": "Unfortunatly, HubRPG still don't support mobile devices... You must have a 1280x720 pixels screen, a keyboard, a mouse and your browser need to be in Desktop Mode",
        "noMobileNext": "Continue anyway",
        "changelog": "View Change Log",
        "language": "Interface's language"
    },
    "changelog": {
        "title": "Change log"
    },
    "tabs": {
        "chat": "Chat",
        "players": "Players",
        "characters": "Characters",
        "scenery": "Scenery",
        "jukebox": "Jukebox",
        "assets": "Assets"
    },
    "tables": {
        "title": "My Tables",
        "create": "Create table",
        "templates": "Charsheet Templates",
        "refresh": "Refresh table list",
        "join": "Join table",
        "waitingaccess": "Waiting GM allow you to join",
        "joinaccess": "You has been invited to enter this table. Do you want to join?",
        "name": "Name",
        "code": "Code",
        "edit": "Edit game",
        "save": "Save game",
        "remove": "Delete game",
        "confirmremove": "Do you really wnat to delete this game? It CANNOT be undone",
        "confirmhighlight": "Once highlighted, it will consume from your month limit, until next month. Do you really want to hightlight this game?",
        "setdate": "Set next game",
        "nextgame": "Next game",
        "date": "Date",
        "dateUndefined": "Date not defined",
        "cancel": "Cancel",
        "player": "Player",
        "players": "Players",
        "selectedSheet": "Character Sheet used",
        "noSheet": "None",
        "public": "Accepting join request?",
        "positions": "Positions occupied",
        "time": "Time to start and finish",
        "time-value": "From $1 until $2",
        "time-value-from": "Starting at $1",
        "time-value-to": "Until $1",
        "time-novalue": "Time not defined",
        "positions-value": "$1 occupied of $2 available",
        "positions-value-nomax": "$1 occupied",
        "content": "Content",
        "tools": "Tools",
        "no-tags": "No Tags Defined",
        "back": "Back",
        "manageSheet": "Sheet Templates Manager",
        "addimage": "Select",
        "thmbnail": "Table image",
        "breakingChanges": "There is awesome new updates. Check this out!",
        "knowMore": "Read more",
        "dismiss": "Dismiss",
        "gotoapoiase": "Go to APOIA.se",
        "noTable": "You have no tables yet. Create or join a table to play",
        "findtables": "Find tables to play",
        "gototables": "Find Tables",
        "hubstatus": "Happening on HubRPG",
        "updateStatus": "Last update released on:",
        "viewRelease": "View updates",
        "underMaintenance1": "We are under maintenance.",
        "underMaintenance2": "Please roll with patience...",
        "twitchOnline": "We are LIVE! Come play together",
        "nextLive": "Next live will be on:",
        "goToTwitch": "Go to Twitch",
        "thankyoupremium1": "Thank you for being Premium!",
        "thankyoupremium2": "Your support helps HubRPG",
        "notpremium1": "You still aren't PREMIUM.",
        "notpremium2": "Be backer to receive bonus",
        "goToApoiase": "Be Backer",
        "tablesCounter": "DM in $1 of $2 tables available",
        "titleFriends": "My friends",
        "more": "More options",
        "searchplaceholder": "Search player",
        "searchbtn": "Search",
        "refreshFriends": "Update friend's list",
        "allFriends": "All",
        "justFriends": "Friends",
        "titleUserProfile": "Profile",
        "noSytemDefined": "System undefined",
        "noContentDefined": "Content undefined",
        "noToolsDefined": "Tools undefined",
        "highlight": "Highlight",
        "highlightUntil": "Game highlighted until",
        "noNameDefined": "No highlight table",
        "noNextDefined": "Date undefined",
        "noOwnerDefined": "GM undefined",
    },
    "userprofile": {
        "addAsFriend": "Request frindship",
        "acceptFriend": "Accept Request",
        "cancelRequest": "Cancel Request",
        "unfriend": "Undo Friendship",
        "age": "Age",
        "ageValue": "years old",
        "gender": "Gender",
        "genderM": "Male",
        "genderF": "Female",
        "genderB": "Not binary",
        "city": "City",
        "bio": "Bio",
        "voice": "Accept Voice?",
        "video": "Accept Video?",
        "stream": "Accept Stream?",
        "pc": "Has PC/Mac?",
        "tablet": "Has Tablet?",
        "phone": "Has Smartphone?",
        "contact": "Contact",
        "availability": "Availability",
        "timeRange": "between $1 and $2",
        "note": "Note",
        "asPlayer": "As Player",
        "asGM": "As Master",
        "acceptInvites": "Accept Invites?",
        "gameSystems": "Game Systems",
        "contentLikeable": "Content Likeable",
        "contentAvoidable": "Content Avoidable",
        "tools": "Tools",
        "playsIn": "Plays in",
        "playsInTables": "Tables",
        "playsInTable": "Table",
        "notSpecified": "Not Specified",
        "unfriend": "Unfriend",
        "block": "Block",
        "unblock": "Unblock",
        "denounce": "Block & Denounce",
        "confirm-unfriend": "Do you really want to unfriend $1",
        "confirm-block": "Do you really want to block $1",
        "confirm-denounce": "Do you really want to block and denounce $1",
        "notdefined": "Not defined",
        "addedSuccessful": "Your request has been sent successfully!",
    },
    "players": {
        "gm": "Game Master",
        "players" : "Players",
        "waiting": "Awaiting approval",
        "update": "Refresh",
        "allowaccess": "Allow",
        "blockaccess": "Deny",
        "addByEmail": "Add player or share table code",
        "email": "Player's email",
        "or": "OR",
        "noParticipants": "There are no parcipants on this table yet. Share the code above or add people by their email",
    },
    "chat": {
        "roll" : "Rolled ",
        "leave": "left the party",
        "enter": " has joined the party",
        "success": " success",
        "success_plural": " successes",
        "critical": " critical",
        "critical_plural": " criticals",
        "fail": " fail",
        "fail_plural": " fails",
        "welcome": "Welcome!",
        "howuse": "Use this chat to send texto to players and game master",
        "howroll": "To roll dices, type:",
        "istyping": "is typing...",
        "hidden": "Hidden roll"
    },
    "gridtools": {
        "scenery": "Sceneries",
        "sceneryname": "Scenery Name",
        "sceneryadd": "Add",
        "sceneryedit": "Save",
        "sceneryactive": "Active",
        "sceneryactivate": "Set active",
        "scenerygridtype": "Grid type",
        "scenerygridsquare": "Square",
        "scenerygridhex": "Hexagon",
        "scenerygridscale": "Grid scale",
        "scenerygridunit": "Unit",
        "scenerygridmeasuretype": "Grid measure type",
        "scenerygridmeasureprecise": "Precise",
        "scenerygridmeasurediamond": "Diamond",
        "scenerygridmeasuresquare": "Square",
        "scenerygridsquarename": "s",
        "tools": "Tools",
        "token": "Token",
        "square": "Square",
        "circle": "Circle",
        "ellipse": "Ellipse",
        "text": "Text",
        "blanktext": "Your text here",
        "polygon": "Polygon",
        "image": "Image",
        "brush": "Brush",
        "labeldraw": "Draw",
        "labelselection": "Selection",
        "labelalign": "Align",
        "snapcenter": "Snap to Center",
        "snapCorner": "Snap to Corner",
        "snapAuto": "Auto Snap",
        "snapFree": "Don't Snap",
        "select": "Select",
        "changelayer": "Move to Layer",
        "bringtofront": "Bring To Front",
        "sendtoback": "Send to Back",
        "addScenery": "New Scenery",
        "properties": "Properties",
        "imagelabel": "Image",
        "textlabel": "Text",
        "colorlabel": "Color",
        "hexlabel": "HEX #",
        "tokenlabel": "Token",
        "filterimage": "Filter images",
        "managefiles": "Manage Files",
        "layers": "Group",
        "layersmove": "Move to Group",
        "baselayer": "Base Group",
        "confirmRemoveLayer": "Delete Group?",
        "confirmRemoveLayerDesc": "Do you really want to delete this Group? It will remove ALL elements into it",
        "confirmdelete": "Do you really want to delete this scenery?",
        "shareChanges": "Show GM's Layer over Player's layer",
        "gmmode": "Your are now in GM's Layer, what means that players are not seeing your changes",
        "tabdraw": "Draw",
        "tabscenery": "Scenery",
        "textplaceholder": "Insert your text here",
        "zoomin": "Zoom In",
        "zoomout": "Zoom Out",
        "jumpcenter": "Jump to Center",
        "openmenu": "Open Menu",
        "gotohelp": "Get Help",
        "turnorder": "Turn Order",
        "editcolor": "Edit Color",
        "disable3dDices": "Disable 3D Dices",
        "enable3dDices": "Enable 3D Dices",
        "tokenOnGrid": "Present in this Grid",
        "timers": "Timers",
    },
    "characters": {
        "playable": "Main Characters",
        "npc": "Non Playable Characters (NPCs)",
        "newChar": "New Character",
        "newNPC": "New NPC",
        "save": "Save",
        "copy": "Copy",
        "saveandback": "Save & Close",
        "name": "Name",
        "unamed": "Unamed?",
        "player": "Player",
        "tags": "Tags",
        "filtertag": "Filter by tag",
        "viewmode": "View",
        "viewlarge": "Expanded",
        "viewcompact": "Compact",
        "ablemultiselect": "Enable Selection",
        "deleteMany": "Delete Selected",
        "confirmMessage1s": "Do you really want to delete this",
        "confirmMessage1p": "Do you really want to delete these",
        "confirmMessage2s": "character?",
        "confirmMessage2p": "characters?",
        "max": "Max",
        "current": "Cur",
        "visibility": "Visibility",
        "showValue": "Show Value and Bar",
        "showSingle": "Show Single Value",
        "showBar": "Show Only Bar",
        "showNone": "Hide both",
        "duplicate": "Duplicate",
        "labelsize": "Token Size",
        "labelwidth": "Width",
        "labelheight": "Height",
        "labelbio": "Bio and Description",
        "labelnotes": "General Notes",
        "confirmRemove": "Do you really want to delete this character?",
        "confirmDuplicate": "How many copies?",
        "openSheet": "Open Character Sheet",
        "openOriginalSheet": "Open Original Character Sheet",
        "openBio": "Bio & Notes",
        "openAbilities": "Abilities",
        "openStatus": "Status",
        "noSheet": "No sheet template defined to this table",
        "newability": "Add new ability",
        "abilityname": "Name",
        "abilitymacro": "Macro",
        "abilityvars": "Variable values",
        "abilitydesc": "Description",
        "abilityaddnewvalue": "Add new variable value",
        "noChars": "There is no characters available. Use the button below to create one",
    },
    "jukebox": {
        "add": "Add audio",
        "name": "Name",
        "youtube": "Youtube's link",
        "volume": "Volume",
        "player": "Player",
        "noMusic": "No videos added. Choose a video from YouTube, copy their link and add to this table",
    },
    "assets": {
        "newAsset": "New Asset",
        "filtertag": "Filter By tag",
        "name": "Name",
        "tags": "Tags",
        "type": "Type",
        "visibility": "Visibility",
        "visibility_0": "Private",
        "visibility_1": "Public",
        "visibility_2": "Specífic people",
        "visibleTo": "Visible To",
        "type_0": "Text",
        "type_1": "Image",
        "type_2": "Table",
        "title": "Assets",
        "afterinsert": "You will be able to set asset's content after create it",
        "confirmRemove": "Do you really want to delete this asset? It cannot be undone",
        "openContent": "Open Asset",
        "showToPlayers": "Show to players",
        "hideFromPlayers": "Hide from players",
        "defaultTextContent": "Insert asset content here",
        "viewerTitle": "Asset View",
        "saveAndContinue": "Save and continue",
        "noAssets": "There are no assets available. Wait for new assets unlocked by table's GM",
        "noAssetsGM": "There are no assets available. Try to create one using button below",
    },
    "texteditor": {
        "bold" : "Bold",
        "italic" : "Italic",
        "underline" : "Underline",
        "h1" : "Title",
        "h2" : "Header",
        "h3" : "Subheader",
        "list" : "List",
        "quote" : "Quote",
        "unindent" : "Reduce Indent",
        "indent" : "Increase Indent"
    },
    "filemanager": {
        "title": "File Manager",
        "upload": "Upload",
        "cancel": "Cancel Selection",
        "confirmUpeload": "Confirm",
        "filename": "Name",
        "filetype": "Type",
        "size": "Size",
        "remove": "Delete selected",
        "confirmRemove": "Do you really want to delete these files?",
        "thisTable": "This table",
        "files": "Files",
        "allTable": "All tables",
        "select": "Select",
        "filesList": "files selected",
        "filesList_": "file selected",
        "status": {
            "waiting": "Saving",
            "error": "Error",
            "ok": "Done"
        }
    },
    "templatemanager" : {
        "title": "Character Sheet Template Manager",
        "titleMin": "Character Sheet Template",
        "cancel": "Cancel",
        "filter": "Search Template",
        "create": "Create",
        "fork": "Copy",
        "edit": "Edit",
        "select": "Select",
        "mytemplates": "My Templates",
        "othertemplates": "Other Templates",
        "nofilter": "To find one sheet template, add a search on field above",
        "noresult": "No public sheet found for this search. Change your seacth or create your own sheet template!",
        "confirmRemove": "Do you really want to delete this template?",
        "owner": "This sheet has been created by you",
        "editor": "You are able to edit this sheet",
        "staff": "This sheet has Best Choice's Medal for this game system",
        "nosystem": "No system",
    },
    "templatebuilder": {
        "name": "Template Name",
        "isPublic": "Allow other tables to use this template",
        "pages": "Number of Pages",
        "editableTo": "Editable To",
        "editableJustMe": "Only you",
        "editableOne": "other player",
        "editableMany": "other players",
        "changeEditableTo": "Change Editors",
        "addfield": "Add Field",
        "component_line": "Text and Label",
        "component_textsolo": "Text without Label",
        "component_label": "Label",
        "component_textint": "Integer Number",
        "component_textfloat": "Decimal Number",
        "component_textarea": "Text Area",
        "component_select": "Options",
        "component_checkbox": "Checkbox",
        "component_group": "Group",
        "component_image": "Image",
        "fieldlabel": "Field Name",
        "fieldname": "Reference",
        "fielddefault": "Default Value",
        "fieldoptions": "Options",
        "isAuto": "Auto calc?",
        "expression": "Expression",
        "macro": "Macro",
        "macromodctrl": "Macro modified by Ctrl Key",
        "image": "Image",
        "textalign": "Text Align",
        "align-left": "Left",
        "align-center": "Center",
        "align-right": "Right",
        "removefield": "Delete field",
        "textsize": "Text Size",
        "size-small": "Small",
        "size-medium": "Medium",
        "size-large": "Large",
        "hasDetails": "Player can add macros/description",
        "commentDetail": "Send description to chat",
        "rollDetail": "Run Macro",
        "valueDetail": "Value",
        "descDetail": "Description",
        "macroDetail": "Macro",
        "xpos": "X Position",
        "ypos": "Y Position",
        "width": "Width",
        "height": "height",
        "save": "Save template",
        "saved": "No changes to save",
        "editors": "Editors",
        "editorsDescription": "You must provide the editor's email to add him/her to this charsheet template. Remember that this email must be that one used to login on HubRPG.",
        "addEditorByEmail": "Email",
        "noEditors": "This template still doesn't have editors. Add people to help improving this charsheet",
        "system": "Game system",
        "systemDescription": "Definir um sistema de jogo permite que jogadores encontrem as mesas que usam este modelo de fichas. Por exemplo, duas pesoas podem criar fichas diferentes para o mesmo RPG. Se ambas definirem o sistema como o mesmo, outrso jogadores seberão que se trada do mesmo RPG, mesmo que cada mesa use um modelo de ficha diferente.",
        "noSystema": "No Game System defined",
        "changeSystem": "Change System",
    },
    "charsheet" : {
        "title" : "Character Sheet",
        "reset": "Reset",
        "addShortcut": "Add Shortcut",
        "removeShortcut": "Remove Shortcut",
        "shortcutsheet": "Sheets",
        "export": "Export",
        "import": "Import",
        "importexport": "Import/Export"
    },
    "turnorder" : {
        "title": "Turn Order",
        "side": "List view",
        "add": "Add",
        "save": "Save",
        "back": "Back",
        "edit": "Edit",
        "emptylist": "No items",
        "name": "Name",
        "token": "Token",
        "value": "Value",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "clear": "Clear list",
        "orderasc": "Order Asc",
        "orderdesc": "Order Desc",
        "currentTurn": "Current Turn",
        "enableappend": "Enable players to add turns",
        "confirmDelete": "Do you really want to delete this item?"
    },
    "bugreport": {
        "title": "Report Bug",
        "heading": "Something went wrong?",
        "description": "If there is something strange or something didn't work as spected, you can use this form to show us what happened. Please, be as much detailed as possible. Oh, if there is a printscreen, it can help us a lot ;D",
        "response": "As soon as possible after problem solved, we will send you an email about the solution.",
        "userdescription": "Description",
        "images": "Images",
        "success": "Success! Your report has been receibed. Soon, there will be a fix. Thank you!",
        "error": "Oops! Something went wrong. Try to send a smaller image or try again...",
    },
    "timers": {
        "title": "Timers",
        "nodata": "No timers created",
        "add": "New Timer",
        "name": "Name",
        "type": "Type",
        "clockTime": "Value",
        "clockup": "Clock",
        "clockdown": "Count Down",
        "statestopped": "Stopped",
        "staterunning": "Running",
        "statepaused": "Paused",
        "play": "Play",
        "pause": "Pause",
        "stop": "Stop",
    },
    "friends": {
        "title": "Friends",
        "seeAll": "See all",
        "noFriends1": "No friends online",
        "noFriends2": "Want to find cool players?<br />Join us on <a href='https://discord.gg/dbBhmUBEhQ'>Discord's</a> server",
        "accept": "Accept",
        "refuse": "Refuse",
        "pending": "Pending requests",
        "online": "Online friends",
        "commonTables": "common tables",
        "invited": "Request sent",
        "accept": "Accept?",
        "noFriends": "There are no friends added yet",
        "noProfiles": "There are no profiles for this query",
        "noBlocked": "There are no blocked profiles",
        "unknown": "You two aren't friends yet",
        "blocked": "You blocked this player",
        "accepted": "Friend request ACCEPTED successfully!",
        "removed": "Friend request REJECTED successfully",
        "unfriend": "Friendship undone. What a bad... :(",
        "viewblocked": "View blocked",
        "blockedsuccess": "Player blocked successfully. It will no more boring you",
        "unblockedsuccess": "Player unblocked successfully!",
        "denoucesuccess": "Denounce registered successfully. Sorry about this thing :(",
        "nousername": "No username",
    },
    "messages": {
        "title": "Messages",
        "seeAll": "See all",
        "noMessagesList": "No unread messages :)",
        "unread": "unread",
        "refresh": "Refresh messages",
        "conversations": "Conversations",
        "conversationWith": "Conversation with",
        "noMessageFriends": "No friends to send message. Add someone first.",
        "noMessages": "You two didn't send any messages yet. It's good time to start playing together!",
        "sendPlaceholder": "Write your message to send",
        "acceptJoin": "Accept",
        "joinText": "Hi! I would like to join this game",
    },
    "findtables": {
        "title": "Find Games",
        "titleHighlight": "Highlighted games",
        "titleCommon": "Public games",
        "filter": "Filter games",
        "more": "and more $1",
    },
    "filter": {
        "title": "Filters",
        "name": "Name",
        "frequency": "Frequency",
        "frequency-any": "Any",
        "frequency-weekly": "Week",
        "frequency-fortnight": "Fortnight",
        "frequency-monthly": "Month",
        "frequency-oneshot": "One Shot",
        "positions": "Positions",
        "positions-gm": "Game Master",
        "positions-player": "Players",
        "positions-any": "Anyone",
        "availability": "Availability",
        "calendar": "Calendar",
        "calendar-auto": "My Availability",
        "calendar-manual": "Manual",
        "calendar-none": "Anyone",
        "calendar-subtitle": "This way, HubRPG will show only games that fits availability set on your profile. Remember keeping your availability updated and find games perfect for your routine!",
        "days": "Days",
        "times": "Times",
        "times-from": "From",
        "times-to": "Until",
        "content-show": "Show",
        "content-hide": "Hide",
        "gamesystems": "Game Systems",
        "gamesystems-show": "Show games for these systems",
        "gamesystems-hide": "Hide games for these systems",
        "gamesystems-none": "No specific game system",
        "gamesystems-filter": "Try type a system to find tags",
        "gamesystems-notfound": "There are no systems with these words. Try another one.",
        "gamesystems-add": "Create this tag",
        "contentFilter": "Content",
        "contentFilter-show": "Show games for these contents",
        "contentFilter-hide": "Hide games for these contents",
        "contentFilter-none": "No specific content",
        "contentFilter-filter": "Try type a content to find tags",
        "contentFilter-notfound": "There are no contents with these words. Try another one.",
        "contentFilter-add": "Create this tag",
        "contentInclude": "Content Likable",
        "contentInclude-show": "Show games for these contents",
        "contentInclude-hide": "Hide games for these contents",
        "contentInclude-none": "No specific content",
        "contentInclude-filter": "Try type a content to find tags",
        "contentInclude-notfound": "There are no contents with these words. Try another one.",
        "contentInclude-add": "Create this tag",
        "contentAvoid": "Content Avoidable",
        "contentAvoid-show": "Show games for these contents",
        "contentAvoid-hide": "Hide games for these contents",
        "contentAvoid-none": "No specific content",
        "contentAvoid-filter": "Try type a content to find tags",
        "contentAvoid-notfound": "There are no contents with these words. Try another one.",
        "contentAvoid-add": "Create this tag",
        "tools": "Tools",
        "tools-show": "Show games for these tools",
        "tools-hide": "Hide games for these tools",
        "tools-none": "No specífic tools",
        "tools-filter": "Try type a tool to find tags",
        "tools-notfound": "There are no tools with these words. Try another one.",
        "tools-add": "Create this tag",
        "tagInclude": "Include",
        "tagAvoid": "Avoid",
        "addButton": "Add",
        "filterButton": "Filter",
        "clearButton": "Clear",
        "filteringBy": "You are filtering tables by these criterias: ",
        "noItemsFilter": "There is no public tables with these criterias. Create one!",
        "noItems": "There are no public tables... Create one now!"
    },
    "tabledetail": {
        "title": "Game Details",
        "ask": "Ask to join",
        "more": "More options",
        "denouce": "Denouce",
        "confirm-denouce": "Do you really want to denouce this game?",
        "next": "Next Game",
        "next-none": "Date not defined",
        "frequency": "Frequency",
        "frequency-weekly": "Week",
        "frequency-fortnight": "Fortnight",
        "frequency-monthly": "Month",
        "frequency-oneshot": "One Shot",
        "frequency-none": "Frequency Not Defined",
        "time": "Time",
        "time-value": "From $1 until $2",
        "time-none": "Time Not Defined",
        "positions": "Positions",
        "positions-value": "$1 free of $2 available",
        "positions-none": "Number of positions not defined",
        "gamesystem": "Game System",
        "gamesystem-none": "Game System not defined",
        "gm": "Game Master",
        "gm-none": "Open for GM",
        "content": "Content in game",
        "content-none": "No Content defined",
        "tools": "Tools used",
        "tools-none": "No Tools defined",
        "players": "Players in game",
        "players-opened": "Position opened",
        "description": "Description",
        "description-none": "No description defined",
    },
    "tableform": {
        "title": "Create new game",
        "title-edit": "Edit game",
        "name": "Table name",
        "charsheet": "Charshet template",
        "charsheet-none": "Template not defined",
        "choose": "Choose",
        "image": "Image",
        "next": "Next game",
        "description": "Description",
        "frequency": "Frequency",
        "frequency-weekly": "Weekly",
        "frequency-fortnight": "Fortnightly",
        "frequency-monthly": "Monthly",
        "frequency-oneshot": "One Shot",
        "start": "Start",
        "end": "End",
        "positions": "Positions",
        "create": "Create",
        "public": "Is Public?",
    },
    "profileform": {
        "title": "Edit your profile",
        "name": "Your name",
        "username": "Username",
        "email": "Email",
        "birthdate": "Birthdate",
        "age": "Age",
        "yearsold": "Years Old",
        "city": "City",
        "state": "State",
        "gender": "Gender",
        "gender-f": "Female",
        "gender-m": "Male",
        "gender-b": "Not binary",
        "visibility-friends": "Friends",
        "visibility-public": "Public",
        "visibility-hide": "Hidden",
        "bio": "Bio",
        "color": "Profile Color",
        "resouces": "Resources",
        "acceptVoice": "Accept Voice?",
        "haspc": "Has PC/Mac?",
        "acceptVideo": "Accept Vídeo",
        "hasTablet": "Has Tablet?",
        "acceptStream": "Accept Stream",
        "hasPhone": "Has Smartphone?",
        "contacts": "Contacts",
        "whatsapp": "Whatsapp",
        "telegram": "Telegram",
        "facebook": "Facebook",
        "instagram": "Instagram",
        "twitter": "Twitter",
        "discord": "Discord",
        "asPlayer": "Player",
        "asGM": "Game Master",
        "acceptInviteToPlay": "Accept invites to play?",
        "acceptInviteToGM": "Accept invites to master?",
        "availability": "Availability",
        "weekday": "Weekday",
        "timestart": "Start",
        "timeend": "Finish",
        "frequency": "Frequency",
        "obs": "Obs",
        "NoAvailability": "You didn't added any time available to play yet",
        "language": "Language"
    },
    "donate": {
        "title": "Did you know?",
        "donate": "Donate",
        "text1": "A nice tool and a space that enhances your RPG as it deserve!",
        "text2": "That's the HubRPG's objective. But to ensure much more quality and even more power to our VTT, we need your help to keep the servers and have more spaces to new features. Support us with what you can ❤",
        "current": "current earnings by month",
        "target": "Monthly target"
    },
    "tutorial": {
        "title": "Welcome to HubRPG",
        "titletable": "How to use this table?",
        "prev": "Previous",
        "next": "Next",
        "title1": "Welcome to HubRPG!",
        "text1": "HubRPG is an online platform to play tabletop RPGs. Our proposal is to have a bunch of tools to help game masters and players to tell imersive and inclusive histories, and generate great moments of fun together.<br />To know more about available resources on HubRPG, visit: <a href='https://hubrpg.com/ajuda'>Página Oficial de Ajuda</a>",
        "title2": "Create your game",
        "text2": "If you are a game master and is going to start a new group, go to \"Create New Game\" and set the name of your table. After joining, you can set character sheets you want to use (you can search on sheets created by others or create your own!), define images and graphics to show to players, create playable or non-playable charactes and play background songs to set environment on your table!",
        "title3": "Invite your friends",
        "text3": "After starting a table, go to tab \"Players\" and share the table code to enable players to join. Don't forget to approve their request, otherwise they will not be able to join!<br />You also can invite them by email, just insert their account's email. On this case, they will have to approve your adding.",
        "title4": "Join a table",
        "text4": "Click at \"Join a game\" and insirt table's code shared by GM<br />After that, just wait bo be allowed to join. Once in game, You can chat, roll dices, see online players, control your tokens and see active Battle Grid",
        "title5": "Support the community",
        "text5": "Enter on our social networks, suggest improviments and share with your friends! HubRPG was made from community to community!",
        "title6": "Batalha Grid",
        "text6": "The largest part of screen shows a battle grid.<br /><br />Your main tools in grid is:<br /><br />Drag using <b>mouse right button</b> to move the scene on screen.<br /><br /><b>Alt+Click</b> send a signal to everyone.<br /><br /><b>Ctrl+Scroll</b> to zoom in or zoom out.",
        "title7": "Chat e Dice Roll",
        "text7": "On right side, the fist tab shows table's chat and rolled dices. To roll dices, you can use the command \"@r\" or then use button's shortcut, on right bottom.",
        "title8": "Sheets, Characters and Tokens",
        "text8": "Other important tab is character controllers. Players will see just tokens attached to them, while GMs will se every single token.<br/><br/>You can see the character sheet, control stats, descriptions e abilities (macros to make automatic rolls. To know more about macros, see in <a href=\"https://hubrpg.com/ajuda\" target=\"_blank\">Help page/a>).<br /><br />But be aware! Every char has one sheet and one token, be careful to do not add token in a map more than once. To GMs, copied characters share the same sheet with original ones.",
        "title9": "Scenery and Graphics",
        "text9": "This tab is available only to GMs. Here, you will be able to draw elements on grid, insert images and set different scenes to show to players.<br/><br/>You can send elements to hidden layer and order then on public view. As last, you can choose how to align elements on grid.",
        "title10": "Jukebox",
        "text10": "On the last tab, you will find controls to play background sounds. Musics should be available on YouTube and only GM can play/stop then, but players can controll their own volume levels."
    },
    "date-mmm": {
        "0":"Jan",
        "1":"Feb",
        "2":"Mar",
        "3":"Apr",
        "4":"May",
        "5":"Jun",
        "6":"Jul",
        "7":"Ago",
        "8":"Sep",
        "9":"Oct",
        "10":"Nov",
        "11":"Dec"
    },
    "date-mm": {
        "0":"January",
        "1":"February",
        "2":"March",
        "3":"April",
        "4":"May",
        "5":"June",
        "6":"July",
        "7":"Agoust",
        "8":"September",
        "9":"October",
        "10":"November",
        "11":"December"
    },
    "date-d": {
        "0":"Sun",
        "1":"Mon",
        "2":"Tue",
        "3":"Wed",
        "4":"Thu",
        "5":"Fri",
        "6":"Sat",
    },
    "date-ddd": {
        "0":"Sunday",
        "1":"Monday",
        "2":"Tuesday",
        "3":"Wednesday",
        "4":"Thursday",
        "5":"Friday",
        "6":"Saturday",
    },
    "dates-ddd": {
        "0":"Sundays",
        "1":"Mondays",
        "2":"Tuesdays",
        "3":"Wednesdays",
        "4":"Thursdays",
        "5":"Fridays",
        "6":"Saturdays",
    },
    "frequencies": {
        "1": "weekly",
        "2": "fortnightly",
        "3": "monthly",
    },
    "denounces": {
        "reason": "Reason",
        "note": "What happened?",
        "boring": "Boring",
        "span": "Spam",
        "content": "Inappropriate Content",
        "racism": "Prejudice/Racism",
        "disrespect": "Disrespect",
        "other": "Other reason",
    },
};